import { currencyFormat } from '@libs/core';
import { TViewCommonOption } from '@libs/types';
import React, { Dispatch, SetStateAction } from 'react';
import { TConsumerItem } from '../../types/data';
import { RowEnum } from '../../types/enums';
import ListItems from '../List/ListItems';
import ListSearchPopup from '../List/popup/ListSearchPopup';
import { SelectorExtraView } from '../UI/Row/SelectorExtraView';

type TListCurrency = {
    header: string;
    noFoundText?: string;
    currencyText?: string;
    searchPlaceholder?: string;
    index: number;
    items: TConsumerItem[];
    handleClick: (id: string) => void;
    isShowSearchFunctionality: boolean;
    parentStyleNames?: TViewCommonOption['parentStyleNames'];
};

const ListCurrency = ({
    items,
    index,
    handleClick,
    isShowSearchFunctionality,
    header,
    noFoundText,
    currencyText,
    searchPlaceholder,
    parentStyleNames,
}: TListCurrency) => {
    const renderItem = ({
        item,
        index,
        isSelected,
        setSelectedIndex,
    }: {
        item: TConsumerItem;
        index: number;
        isSelected?: boolean;
        setSelectedIndex?: Dispatch<SetStateAction<number | undefined>>;
    }) => {
        const newItem = {
            id: RowEnum.SELECTOR_EXTRA,
            title: item.title,
            subtitle: item.amount ? `${currencyText} ${currencyFormat(item.amount)} ${item?.iso?.toUpperCase() ?? ''}` : '',
            iconName: `ic_${item?.iso?.toLowerCase()}`,
            defaultIconName: 'ic_default_currency',
            iconVariant: 'circle',
            iconHierarchy: 'primary',
            metaText: item.metaText,
        } as TConsumerItem;
        return (
            <SelectorExtraView
                key={item.id}
                isSelected={isSelected}
                parentStyleNames={parentStyleNames}
                handleClick={() => {
                    setSelectedIndex?.(index);
                    if (item?.value) {
                        handleClick(item.value as string);
                    }
                }}
                {...newItem}
            />
        );
    };
    if (isShowSearchFunctionality) {
        return (
            <ListSearchPopup
                header={header}
                noFoundText={noFoundText}
                items={items}
                renderItem={renderItem}
                index={index}
                searchPlaceholder={searchPlaceholder}
                styleName="calculatorCurrencyListTitle"
                parentStyleNames={parentStyleNames}
            />
        );
    }
    if (items && Array.isArray(items) && items.length > 0) {
        return <ListItems items={items} renderItem={renderItem} currentIndex={index} />;
    }
    return null;
};

export { ListCurrency };
